// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CaretUpOutlinedSvg from "@ant-design/icons-svg/es/asn/CaretUpOutlined";
import AntdIcon from '../components/AntdIcon';

var CaretUpOutlined = function CaretUpOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CaretUpOutlinedSvg
  }));
};

CaretUpOutlined.displayName = 'CaretUpOutlined';
export default React.forwardRef(CaretUpOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CaretUpOutlined.js
// module id = 739
// module chunks = 0